// extracted by mini-css-extract-plugin
module.exports = {"container":"VerticalProgressBar_container__3joDN","fill":"VerticalProgressBar_fill__2iw6w","fillUp":"VerticalProgressBar_fillUp__1SVRz","label":"VerticalProgressBar_label__2dEUw"};